import { Component, OnInit } from '@angular/core';

@Component({
  template: require('./viagens.component.html')
})
export class ViagensComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/viagens/viagens.component.ts
 **/